export default __webpack_public_path__ + "static/media/file.c815c986.svg";